import type { FunctionComponent } from 'react';

import InboxIcon from '@atlaskit/icon/core/inbox';

import styles from './StubInbox.less';

export const StubInbox: FunctionComponent = () => {
  return (
    <header className={styles.header}>
      <InboxIcon label="" spacing="spacious" />
      <span>Inbox</span>
    </header>
  );
};
